import { Directive, ContentChildren, Input, Output, QueryList, ElementRef, EventEmitter, OnInit, AfterViewInit, OnDestroy } from '@angular/core';

import { Subscription } from 'rxjs';
import * as _ from 'lodash';

import { DragAndDropService, DragAndDropEvent } from './drag-and-drop.service';

import { DraggableDirective } from './draggable.directive';
import { DropZone } from './classes/drop-zone';

@Directive({
  selector: '[uexDropZone]',
  host: {
    '[class.uex-drop-zone]': 'enabled',
    '[class.dragging-over]': 'dragging_over'
  }
})
export class DropZoneDirective implements OnInit, AfterViewInit, OnDestroy {
  @ContentChildren(DraggableDirective) private _draggable_children: QueryList<DraggableDirective>;

  @Input('uexDropZone') private set _setEnabled(enabled: boolean | string) {
    if (_.isString(enabled) && _.isEmpty(enabled)) {
      this.enabled = true;
    } else {
      this.enabled = !!enabled;
    }

    this.drop_zone.setEnabled(this.enabled);
  }

  @Input('uexDropZoneExclude') private set _setDropZoneRestriction(restriction: string | string[]) {
    this.drop_zone_restriction = restriction;
    this.drop_zone.setRestriction(this.drop_zone_restriction);
  }
  @Input('uexDropZoneDragOverClass') public drop_zone_drag_over_class: string;

  @Output('onDragEnter') public onDragEnter: EventEmitter<DragEvent> = new EventEmitter();
  @Output('onDragLeave') public onDragLeave: EventEmitter<DragEvent> = new EventEmitter();

  @Output('onDrop') public onDrop: EventEmitter<DragAndDropEvent> = new EventEmitter();
  @Output('onRemove') public onRemove: EventEmitter<DragAndDropEvent> = new EventEmitter();

  constructor(
    private _service: DragAndDropService,
    public elementRef: ElementRef
  ) {
    this.drop_zone = this._service.registerDropZone({
      element: this._element
    });
  }

  public enabled = true;
  public dragging_over = false;
  public drop_zone_restriction: string | string[];

  public drop_zone: DropZone;
  private _drag_enter_subscription: Subscription;
  private _drag_leave_subscription: Subscription;
  private _drop_subscription: Subscription;
  private _remove_subscription: Subscription;

  public ngOnInit() {
    this._drag_enter_subscription = this.drop_zone.onEnter.subscribe((event: DragEvent) => {
      if (this.dragging_over) { return; }

      this.dragging_over = true;
      if (this.drop_zone_drag_over_class) { this._element.classList.add(this.drop_zone_drag_over_class); }

      this.onDragEnter.emit(event);
    });

    this._drag_leave_subscription = this.drop_zone.onLeave.subscribe((event: DragEvent) => {
      if (!this.dragging_over) { return; }

      this.dragging_over = false;
      if (this.drop_zone_drag_over_class) { this._element.classList.remove(this.drop_zone_drag_over_class); }

      this.onDragLeave.emit(event);
    });

    this._drop_subscription = this.drop_zone.onDrop.subscribe((event: DragAndDropEvent) => {
      this.onDrop.emit(event);
    });

    this._remove_subscription = this.drop_zone.onRemove.subscribe((event: DragAndDropEvent) => {
      this.onRemove.emit(event);
    });
  }

  public ngAfterViewInit() {
    this.drop_zone.setDraggableChildren(this._draggable_children.map((child) => child.draggable));
  }

  public ngOnDestroy() {
    if (this._drag_enter_subscription) { this._drag_enter_subscription.unsubscribe(); }
    if (this._drag_leave_subscription) { this._drag_leave_subscription.unsubscribe(); }
    if (this._drop_subscription) { this._drop_subscription.unsubscribe(); }
    if (this._remove_subscription) { this._remove_subscription.unsubscribe(); }

    this._service.unregisterDropZone(this.drop_zone);
  }

  private get _element (): HTMLElement {
    return this.elementRef.nativeElement;
  }
}
